import request from "@/utils/request";
import { getToken, setToken, removeToken } from "@/utils/auth";
import { getExpoAreaList } from "@/utils/common";
import router from "@/router/index";
import { getRules } from "@/api/auth";
import { getVerifyInfo } from "@/api/common";
import i18n from "@/locales/i18n";
import Cookies from "js-cookie";

import Layout from "@/views/Layout/Index.vue";

let currLang = "/";
let currentLocale = "cn";
if (window.location.pathname.indexOf("/en") == 0) {
  currLang = "/en";
  currentLocale = "en";
  i18n.global.locale.value = "en";
}
if (window.location.hostname == "exhibitor.sialchina.com") {
  currentLocale = "en";
  i18n.global.locale.value = "en";
}

const state = {
  roles: Cookies.get("roles"), // 1：普通， 2：往届， 3：当届， 5：当届国际展商
  token: getToken(),
  routers: [],
  expo_area_list: [], //当届参展的展会区域
  verifyInfo: [], // 会刊展品完成度凭证
  show_matchmaking: Cookies.get("show_matchmaking") || false,
  show_precisematch: Cookies.get("show_precisematch") || false,
  show_badges: Cookies.get("show_badges") || false,
  show_steak: Cookies.get("show_steak") || false,
  show_invite: Cookies.get("show_invite") || false,
  show_precisebooth_sh: Cookies.get("show_precisebooth_sh") || 0,
  show_precisebooth_sz: Cookies.get("show_precisebooth_sz") || 0,
};
const mutations = {
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_ROUTERS: (state, data) => {
    state.routers = data;
  },
  SET_AREA_EXPO_LIST: (state, list) => {
    state.expo_area_list = list;
  },
  SET_VERIFYINFO: (state, data) => {
    state.verifyInfo = data;
  },
  SET_MATCHMAKING: (state, data) => {
    state.show_matchmaking = data;
  },
  SET_PRECISEEMATCH: (state, data) => {
    state.show_precisematch = data;
  },
  SET_BADGES: (state, data) => {
    state.show_badges = data;
  },
  SET_STEAK: (state, data) => { 
    state.show_steak = data;
  },
  SET_INVITE: (state, data) => {
    state.show_invite = data;
  },
  SET_PRECISEEBOOTH_SH: (state, data) => {
    state.show_precisebooth_sh = data;
  },
  SET_PRECISEEBOOTH_SZ: (state, data) => {
    state.show_precisebooth_sz = data;
  },
};

const actions = {
  // 登录
  login({ commit }, userInfo) {
    const { is_frence } = userInfo;
    console.log("login-is_frence", is_frence);
    if (!is_frence) {
      return new Promise((resolve, reject) => {
        request({
          url: "/exhibitor/do_login",
          method: "post",
          data: userInfo,
        })
          .then(async (response) => {
            const { data } = response;

            // 存放令牌状态
            commit("SET_TOKEN", data.jwt);
            commit("SET_ROLES", data.payload.roles);
            Cookies.set("roles", data.payload.roles);
            Cookies.set("account", data.payload.account);
            Cookies.set("token_login", data.payload.token_login);
            Cookies.set("show_precisebooth_sh", data.payload.is_sh_booth_menu);
            Cookies.set("show_precisebooth_sz", data.payload.is_sz_booth_menu);
            commit("SET_PRECISEEBOOTH_SH", data.payload.is_sh_booth_menu);
            commit("SET_PRECISEEBOOTH_SZ", data.payload.is_sz_booth_menu);

            setToken(data.jwt);

            await getVerifyInfo({ app_lang: i18n.global.locale.value })
              .then((res) => {
                const { data } = res;
                commit("SET_VERIFYINFO", data);
              })
              .catch(() => {});

            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    } else {
      // 法国单点登录
      const { inscription_id } = userInfo;
      return new Promise((resolve, reject) => {
        request({
          url: "/exhibitor/french_ssoLogin",
          method: "post",
          data: { inscription_id },
        })
          .then((response) => {
            const { data } = response;
            // 存放令牌状态
            commit("SET_TOKEN", data.jwt);
            commit("SET_ROLES", data.payload.roles);
            Cookies.set("roles", data.payload.roles);
            Cookies.set("account", data.payload.account);
            Cookies.set("token_login", data.payload.token_login);

            Cookies.set("show_precisebooth_sh", data.payload.is_sh_booth_menu);
            Cookies.set("show_precisebooth_sz", data.payload.is_sz_booth_menu);
            commit("SET_PRECISEEBOOTH_SH", data.payload.is_sh_booth_menu);
            commit("SET_PRECISEEBOOTH_SZ", data.payload.is_sz_booth_menu);

            setToken(data.jwt);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  },

  // 退出登录
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      request({
        url: "/exhibitor/logout",
        method: "GET",
        data: "",
      })
        .then(() => {
          // 清除令牌状态
          commit("SET_TOKEN", "");
          commit("SET_ROUTERS", []);

          Cookies.remove("roles");
          Cookies.remove("account");
          Cookies.remove("token_login");
          Cookies.remove("invitevst_pages");
          Cookies.remove("invitevst_index");
          removeToken();
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // 获取动态路由
  generateRoutes({ dispatch, commit, state, rootState }) {
    // console.log('---rootState', state,'\n', rootState);

    return new Promise((resolve, reject) => {
      getRules()
        .then(async (res) => {
          const { data } = res;

          // 判断邀请客户是否关闭
          const showInvite = handleShowRuleBtn(data, 96);
          console.log("showInvite", showInvite);
          commit("SET_INVITE", showInvite);
          Cookies.set("show_invite", showInvite);

          // 判断商贸配对是否关闭
          const showMatch = handleShowRuleBtn(data, 13);
          commit("SET_MATCHMAKING", showMatch);
          Cookies.set("show_matchmaking", showMatch);

          // 判断供需对接是否关闭
          const showPreciseMatch = handleShowRuleBtn(data, 86);
          commit("SET_PRECISEEMATCH", showPreciseMatch);
          Cookies.set("show_precisematch", showPreciseMatch);

          // 判断胸卡是否关闭
          const showBadges = handleShowRuleBtn(data, 36);
          commit("SET_BADGES", showBadges);
          Cookies.set("show_badges", showBadges);

          // 判断臻牛奖
          const showSteak = handleShowRuleBtn(data, 97);
          commit("SET_STEAK", showSteak);
          Cookies.set("show_steak", showSteak);


          // 获取展商参展的当届展区
          await getExpoAreaList()
            .then((res) => {
              const { data } = res;
              commit("SET_AREA_EXPO_LIST", data);
            })
            .catch(() => {});

          const filterName = [];
          let area_id = [];
          state.expo_area_list.map((o) => {
            area_id.push(o.id);
          });
          if (!area_id.includes(1)) {
            filterName.push("上海创新大赛");
          }
          if (!area_id.includes(2)) {
            filterName.push("广州创新大赛");
          }

          if (data.length == 0) {
            data.push({
              id: 1,
              title: "首页",
              page_url: "Index/index",
              uri: "Index/index",
              condition: "",
              redirect: "",
              pid: 0,
              is_menu: 1,
              icon: "fa fa-home",
              remark: "",
              sort: 0,
              status: 1,
              delete_time: 0,
              spacer: "",
              childlist: [],
            });
          }

          const curr_expo = rootState.is_now_expoid[0] == 1 ? "sh" : "sz";
          let accessedRoutes = rulesToRouters(
            data,
            filterName,
            state,
            curr_expo,
          );
          accessedRoutes = addExtraRouters(accessedRoutes);

          console.log("accessedRoutes", accessedRoutes);
          commit("SET_ROUTERS", accessedRoutes);
          dispatch("addRoutes", accessedRoutes);
          resolve(accessedRoutes);
        })
        .catch((err) => {
          // showMsg.error(err.msg);
          reject();
        });
    });
  },
  addRoutes({ commit }, accessRoutes) {
    // 添加动态路由
    accessRoutes.forEach((route) => {
      // console.log("route", route);
      router.addRoute(route);
    });
  },
};

function rulesToRouters(data, filterName, state, curr_expo) {
  const show_precisebooth = Cookies.get("show_precisebooth_" + curr_expo);

  if (!data.length) {
    return [];
  }
  const routes = [];
  const filterUriEn = [
    "Badges/badgesEmbedded",
    "Sponsor/index",
    "Company/contacts",
  ];
  const filterUriCn = ["Visa/index"];
  // console.log("process.env.NODE_ENV",process.env.NODE_ENV);
  if (process.env.NODE_ENV == "productiontest") {
    filterUriCn.push("Badges/badgesEmbedded");
  }
  let filterNames = filterName;

  data.map((o, i) => {
    if (
      (currentLocale == "en" &&
        !filterUriEn.includes(o.uri) &&
        !filterNames.includes(o.title)) ||
      (currentLocale == "cn" &&
        !filterUriCn.includes(o.uri) &&
        !filterNames.includes(o.title))
    ) {
      let routeItem;
      var path;
      var uri = o.uri;
      if (uri.indexOf("http") != -1 && currentLocale == "en") {
        let url = new URL(uri);
        if (url.host == "visitor.sialchina.cn") {
          uri = `https://visitor.sialchina.com${url.pathname}${url.search}`;
        }
        if (url.host == "www.sialchina.cn") {
          uri = `https://www.sialchina.com${url.pathname}${url.search}`;
        }
      }
      if (o.condition) {
        path = o.uri ? `${o.uri}?${o.condition}` : currLang;
      } else {
        path = uri || currLang;
      }
      if (o.pid == 0) {
        if (!o.childlist || o.childlist.length == 0) {
          routeItem = {
            path: currLang,
            component: Layout,
            name: i18n.global.t(`meta.${o.title}`),
            meta: {
              title: i18n.global.t(`meta.${o.title}`),
              icon: o.icon,
            },
            children: [
              {
                path: path,
                component: o.page_url
                  ? () => import(`@/views/${o.page_url}.vue`)
                  : "",
                meta: {
                  title: i18n.global.t(`meta.${o.title}`),
                  icon: o.icon,
                },
              },
            ],
          };
        } else {
          routeItem = {
            path: path,
            component: Layout,
            name: i18n.global.t(`meta.${o.title}`),
            meta: {
              title: i18n.global.t(`meta.${o.title}`),
              icon: o.icon,
            },
            children: [],
          };
        }
      } else {
        routeItem = {
          path: path,
          component: o.page_url
            ? () => import(`@/views/${o.page_url}.vue`)
            : "",
          name: i18n.global.t(`meta.${o.title}`),
          meta: {
            title: i18n.global.t(`meta.${o.title}`),
            icon: o.icon,
          },
          hidden:
            o.uri === "PreciseMatch/boothMatching" && show_precisebooth != 1,
        };
      }
      if (o.childlist && o.childlist.length > 0) {
        routeItem.children.push(
          ...rulesToRouters(o.childlist, filterName, state, curr_expo),
        );
      }
      routes.push(routeItem);
    }
  });
  return routes;
}

function addExtraRouters(data) {
  console.log("addExtraRouters----data", data)
  const host = ["exhibitor.sialchina.cn", "exhibitor.sialchina.com"];
  let accessedRoutes = data;
  if (
    !host.includes(window.location.hostname) &&
    window.location.pathname.indexOf("/en") == 0
  ) {
    accessedRoutes.push({
      path: "/en/:pathMatch(.*)*",
      redirect: "/en/Index/index",
    });
  }
  // const downloadIndex = accessedRoutes.findIndex(function (o) {
  //   return o.name == i18n.global.t("meta.下载中心");
  // });
  // accessedRoutes.splice(downloadIndex, 0, {
  //   path: currLang,
  //   children: [
  //     {
  //       path: `Invitation/customer`,
  //       meta: { title: i18n.global.t("meta.客户邀请函"), icon: "fa fa-users" },
  //     },
  //   ],
  // });
  // accessedRoutes.push({
  //   path: currLang,
  //   children: [
  //     {
  //       path:
  //         currentLocale == "en"
  //           ? "https://www.sialchina.com/events/steak.html"
  //           : "https://www.sialchina.cn/events/steak.html",
  //       meta: { title: i18n.global.t("meta.臻牛奖"), icon: "fa fa-trophy" },
  //     },
  //   ],
  // });
  const donwloadIndex = accessedRoutes.findIndex(function (o) {
    return o.name == i18n.global.t("meta.下载中心");
  });
  accessedRoutes.splice(donwloadIndex, 0, {
    path: currLang,
    children: [
      {
        path:
          currentLocale == "en"
            ? `https://catalogue.sialchina.cn/en/siglelogin?account=${Cookies.get(
                "account",
              )}&token_login=${Cookies.get("token_login")}`
            : `https://catalogue.sialchina.cn/siglelogin?account=${Cookies.get(
                "account",
              )}&token_login=${Cookies.get("token_login")}`,
        meta: { title: i18n.global.t("meta.电子会刊"), icon: "fa fa-book" },
      },
    ],
  });
  accessedRoutes.push({
    path: "/:pathMatch(.*)*",
    redirect: "/Index/index",
  });
  return accessedRoutes;
}

function handleShowRuleBtn(data, id) {
  if (!data || !Array.isArray(data)) {
    return false;
  }

  for (const item of data) {
    if (item.id == id) {
      return true;
    }

    if (item.childlist && item.childlist.length > 0) {
      const foundInChild = handleShowRuleBtn(item.childlist, id);
      if (foundInChild) {
        return true;
      }
    }
  }
  return false;
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
